import { render, staticRenderFns } from "./incomeDetail.vue?vue&type=template&id=04b4e786&scoped=true"
import script from "./incomeDetail.vue?vue&type=script&lang=js"
export * from "./incomeDetail.vue?vue&type=script&lang=js"
import style0 from "./incomeDetail.vue?vue&type=style&index=0&id=04b4e786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4e786",
  null
  
)

export default component.exports